/**
 * Map a cadence (in days) to the human-friendly frequency label used by
 * compliance teams, so the UI feels familiar to clients.
 *
 * Maps the standard cadences exactly; falls back to "Every N days" for
 * non-standard ones.
 */
export const frequencyLabel = days => {
  if (days === null || days === undefined) return '—'
  const d = Number(days)
  if (!Number.isFinite(d) || d <= 0) return '—'
  if (d === 1) return 'Daily'
  if (d === 7) return 'Weekly'
  if (d === 14) return 'Fortnightly'
  if (d >= 28 && d <= 31) return 'Monthly'
  if (d === 60 || d === 61) return '2 Monthly'
  if (d === 90 || d === 91 || d === 92) return 'Quarterly'
  if (d === 120 || d === 122) return '4 Monthly'
  if (d >= 180 && d <= 183) return '6 Monthly'
  if (d >= 365 && d <= 366) return 'Annual'
  if (d >= 730 && d <= 732) return '2 Yearly'
  if (d >= 1095 && d <= 1098) return '3 Yearly'
  if (d >= 1460 && d <= 1464) return '4 Yearly'
  if (d >= 1820 && d <= 1830) return '5 Yearly'
  if (d >= 3650 && d <= 3660) return '10 Yearly'
  return `Every ${d} days`
}
